export default "/images/calendrier.svg?511f5d343c130945c748e17b59b62ef3";